import styled from 'styled-components';
import {Accordion as DefaultAccordion} from './Accordion';
import React from 'react';
import {ScreenSizes, Sx} from '../../types/responsive';
import {SectionHeader} from './Section';

const FaqSection = styled.section`
  padding: 0.5rem 30px 0.625rem;
  width: 100%;
  max-width: 820px;
  margin: auto;
  p {
    line-height: 150%;
  }
  @media (max-width: ${ScreenSizes.md}) {
    padding: 0.5rem 0 0.625rem;
  }
`;

const Accordion = styled(DefaultAccordion)`
  margin-bottom: 12px;
`;

const FaqTitle = styled(SectionHeader)`
  padding: 0 40px;
  margin: auto;
  text-align: center;
  @media (max-width: ${ScreenSizes.md}) {
    padding: 0;
    width: 100%;
  }
`;
export type Faq = {
  header: string | JSX.Element;
  // Plain-text question for the schema, required when `header` is JSX (e.g. a
  // <Trans> with a link). Accepts a raw Trans key: its <1>…</1> tags are stripped.
  name?: string;
  content?: JSX.Element | string;
  text?: string;
};

export const getFaqSchema = (faqs: Faq[]) => ({
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.name ? faq.name.replace(/<\/?\d+>/g, '') : faq.header,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.text
    }
  }))
});

export const FaqsSection: React.FC<{
  title: string | JSX.Element;
  faqs: Faq[];
  sx?: Sx;
  id?: string;
}> = ({faqs, title, id}) => {
  return (
    <>
      <FaqTitle underline id={id}>
        {title}
      </FaqTitle>
      <FaqSection className="faqs-section">
        {faqs.map((faq, index) => (
          <Accordion key={index} header={faq.header}>
            <p>{faq.content}</p>
          </Accordion>
        ))}
      </FaqSection>
    </>
  );
};
